import SearchDropdown from './searchDropdown';
interface Props {
  required?: boolean;
  dummyOption?: boolean;
  isClearable?: boolean;
  isSearchable?: boolean;
  selectedAirBase: any;
  setSelectedAirBase: any;
  airbaseList: any;
  setHandleToggleChange?: any;
  label?: any;
  id: string;
}
const SelectAirbasesDropdown = ({
  required = false,
  isClearable = false,
  isSearchable = true,
  dummyOption = true,
  selectedAirBase,
  setSelectedAirBase,
  airbaseList,
  setHandleToggleChange,
  label,
  id,
}: Props) => {
  return (
    <SearchDropdown
      id={id}
      required={required}
      isClearable={isClearable}
      isSearchable={isSearchable}
      label={label && label}
      selectedValue={selectedAirBase}
      options={airbaseList && airbaseList}
      dummyOption={dummyOption}
      onSelect={(item) => {
        setSelectedAirBase && setSelectedAirBase(item.value);
        setHandleToggleChange && setHandleToggleChange(true);
      }}
    />
  );
};

export default SelectAirbasesDropdown;
